import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog } from './ui';

/** "Are you sure?" for soft warnings (G-7) and destructive actions. */
export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  children,
  confirmLabel,
  onConfirm,
  danger,
  confirmDisabled,
}: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  title: ReactNode;
  children?: ReactNode;
  confirmLabel?: ReactNode;
  onConfirm: () => void | Promise<void>;
  danger?: boolean;
  confirmDisabled?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      footer={
        <>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            {t('common.cancel')}
          </Button>
          <Button
            variant={danger ? 'danger' : 'primary'}
            disabled={confirmDisabled}
            onClick={async () => {
              await onConfirm();
              onOpenChange(false);
            }}
          >
            {confirmLabel ?? t('common.confirm')}
          </Button>
        </>
      }
    >
      {children}
    </Dialog>
  );
}
